import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-md-12 col-lg-9 order-1 order-md-2 mb-4 mb-md-0" }
const _hoisted_2 = { class: "card vt-news-card breadcrumb-card mb-3" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { "aria-label": "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = { class: "place-button" }
const _hoisted_10 = { class: "btn btn-primary" }
const _hoisted_11 = { class: "card p-3" }
const _hoisted_12 = { class: "flex items-end md:flex-nowrap gap-3 mb-3" }
const _hoisted_13 = { class: "w-full md:w-1/4" }
const _hoisted_14 = { class: "w-full md:w-1/4" }
const _hoisted_15 = { class: "w-full md:w-1/4" }
const _hoisted_16 = { class: "w-full md:w-1/4" }
const _hoisted_17 = { class: "flex gap-2 w-full md:w-1/4" }
const _hoisted_18 = {
  key: 0,
  class: "p-1 rounded btn-success m-1"
}
const _hoisted_19 = {
  key: 1,
  class: "p-1 rounded btn-danger m-1"
}
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons size-font-ahalf" }, " add ", -1)
const _hoisted_22 = ["onClick"]

import {useApi} from '../../utils/api';
 import { useRoute } from 'vue-router';
  import { ref, watch, reactive, onMounted } from "vue";
  import type { Header, Item, HeaderItemClassNameFunction, BodyItemClassNameFunction } from "vue3-easy-data-table";

  import VTInput from '../../elements/VTInput.vue'; 
  import VTButton from '../../elements/VTButton.vue'; 
  import VTSelect from '../../elements/VTSelect.vue'; 
  import { useToast } from "vue-toast-notification";
  import { useI18n } from "vue-i18n";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'steps',
  setup(__props) {

 
  const { t } = useI18n();
  
    const dataTable = ref();
    const route = useRoute();
    const league = ref({});
    const stepId = ref(0);

    const initialFormState = {
        title: '',
        priority: 0,
        current: 0,
        status: 0,
    };


    const getLeague = () => {
        if (route.params.id != undefined) {
            useApi().get(`/api/profile/leagues/${route.params.id}`)
                .then((response) => {
                    league.value = response?.data;
                });

        }
    }

    const currentList = ref([
        {
            id:0,
            title: t('site.Inactive')
        },
        {
            id:1,
            title: t('site.Active')
        }
    ]);

    const statusList = ref([
        {
            id:0,
            title: t('site.Inactive')
        },
        {
            id:1,
            title: t('site.Active')
        }
    ]);

 const form = reactive({ ...initialFormState });

  const searchField = ref("title");
  const searchValue = ref("");
  const headers: Header[] = [
    { text: t('site.Title'), value: "title" },
    { text: t('site.Priority'), value: "priority" },
    { text: t('site.Current step'), value: "current" },
    { text: t('site.Status'), value: "status", sortable: true },
    { text: t('site.Manage'), value: "actions" },
  ];
  
  const items = ref<Item[]>([]);
  
  const loading = ref(false);
  const serverItemsLength = ref(0);
  const serverOptions = ref({
    page: 1,
    rowsPerPage: 25,
    sortBy: 'id',
    sortType: 'desc',
    query: '',
  });

  const headerItemClassNameFunction: HeaderItemClassNameFunction = (): string => {
    return 'vt-bg-text';
  };

  const bodyItemClassNameFunction: BodyItemClassNameFunction = (): string => {   
    return 'direction-right';
  };
  
  const loadFromServer = async () => {
    loading.value = true;
    await useApi().get(`/api/profile/leagues/${route.params.id}/steps`, serverOptions.value)
    .then((response: any) => {
        items.value = response.data;
    })
    loading.value = false;
  };

  const $toast = useToast();
  
  const editItem = (id: Number) => {
    const temp = items.value.find(item => item.id == id);
    if (temp) {
        const { id, title, priority, current, status } = temp;
        form.title = title;
        form.priority = priority;
        form.current = current;
        form.status = status;
        stepId.value = id
    }
  };

  const resetForm = () => {
    Object.assign(form, { ...initialFormState });
    stepId.value = 0;
  };

  const send = () => {
    
    let url = `/api/profile/leagues/${route.params.id}/steps`;

    if (stepId.value > 0) {
        url = `/api/profile/leagues/${route.params.id}/steps/${stepId.value}`;
    }

    useApi().post(url, form)
    .then((response) => {
        if (response.data.status) {
            $toast.success(response.data.message);
            resetForm();
            loading.value = true;
            stepId.value = 0;
            setTimeout(() => { loadFromServer(); loading.value = false; }, 1000);
        }
    })
    .catch(error => {
        if (error?.response?.data?.status == 0) {
            $toast.error(error.response.data.message);
        }
    })
  };

  
  // initial load
  onMounted(() => {


    window.document.title =   `${t('site.League management')} | ${t('site.Website name')}`;
    if (route.params.id) {
        getLeague();
        loadFromServer();
    }

});
  
  watch(serverOptions, () => { loadFromServer(); }, { deep: true });


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ol", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/profile",
                title: _ctx.$t('site.Profile')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('site.Profile')), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/profile/leagues",
                title: _ctx.$t('site.League management')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('site.League management')), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _createElementVNode("li", _hoisted_8, _toDisplayString(league.value?.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/profile/leagues",
            title: _ctx.$t('site.Create new league')
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.$t('site.League management')), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(VTInput, {
            class: "mt-2",
            "is-vt": true,
            name: "title",
            modelValue: form.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
            label: _ctx.$t('site.Title')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(VTInput, {
            class: "mt-2",
            "input-type": "number",
            "is-vt": true,
            name: "priority",
            modelValue: form.priority,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.priority) = $event)),
            label: _ctx.$t('site.Priority')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(VTSelect, {
            class: "mt-2",
            "is-vt": true,
            label: _ctx.$t('site.Current step'),
            modelValue: form.current,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.current) = $event)),
            options: currentList.value,
            optionsValueKey: "id",
            optionsDisplayValueKey: "title",
            name: "current"
          }, null, 8, ["label", "modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(VTSelect, {
            class: "mt-2",
            "is-vt": true,
            label: _ctx.$t('site.Status'),
            modelValue: form.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.status) = $event)),
            options: statusList.value,
            optionsValueKey: "id",
            optionsDisplayValueKey: "title",
            name: "status"
          }, null, 8, ["label", "modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(VTButton, {
            class: "justify-center btn-outline-secondary btn-sm mt-4",
            size: "medium",
            color: "primary",
            onClick: send
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(stepId.value > 0 ? _ctx.$t('site.Edit') : _ctx.$t('site.Add')), 1)
            ]),
            _: 1
          }),
          (stepId.value > 0)
            ? (_openBlock(), _createBlock(VTButton, {
                key: 0,
                class: "justify-center btn-outline-secondary btn-sm mt-4",
                size: "medium",
                color: "default",
                onClick: resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('site.Cancel')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_EasyDataTable, {
        ref_key: "dataTable",
        ref: dataTable,
        "server-options": serverOptions.value,
        "onUpdate:serverOptions": _cache[4] || (_cache[4] = ($event: any) => ((serverOptions).value = $event)),
        "server-items-length": serverItemsLength.value,
        loading: loading.value,
        headers: headers,
        items: items.value,
        "show-index": "",
        "search-field": searchField.value,
        "search-value": searchValue.value,
        "header-item-class-name": headerItemClassNameFunction,
        "body-item-class-name": bodyItemClassNameFunction,
        "hide-footer": "",
        "border-cell": "",
        alternating: ""
      }, {
        "item-status": _withCtx((item) => [
          (item.status == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('site.Active')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('site.Inactive')), 1))
        ]),
        "item-actions": _withCtx((item) => [
          _createElementVNode("div", _hoisted_20, [
            (league.value?.type == 2)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "p-1 rounded btn-warning m-1 text-white",
                  to: '/profile/steps/' + item.id + '/clubs'
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              class: "px-2 py-1 rounded btn-warning m-1 text-white text-decoration-none",
              to: '/profile/steps/' + item.id + '/matches'
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('site.Match management')), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("span", {
              onClick: ($event: any) => (editItem(item.id)),
              class: "p-1 rounded btn-info m-1 text-white material-icons size-font-ahalf cursor-pointer"
            }, " edit ", 8, _hoisted_22)
          ])
        ]),
        "empty-message": _withCtx(() => [
          _createElementVNode("a", null, _toDisplayString(_ctx.$t('site.nothing here')), 1)
        ]),
        _: 1
      }, 8, ["server-options", "server-items-length", "loading", "items", "search-field", "search-value"])
    ])
  ]))
}
}

})